import {event} from "./selection/on";

export default function() {
  var current = event, source;
  while (source = current.sourceEvent) current = source;
  return current;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/sourceEvent.js
// module id = 86
// module chunks = 0 1 2 3 4